// extracted by mini-css-extract-plugin
export default {"SetupRoundTabs":"SetupRoundTabs_SetupRoundTabs__HrlBp","TablList":"SetupRoundTabs_TablList__m+CSY","Panel":"SetupRoundTabs_Panel__24o9t"};